import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

/* Unauthenticated components */
import Login from "../components/routes/unauthenticated/Login.vue";
import ForgotPasswordScreen from "../components/routes/unauthenticated/ForgotPasswordScreen.vue";
import ResetPasswordScreen from "../components/routes/unauthenticated/ResetPasswordScreen.vue";
import Error404 from "../components/routes/unauthenticated/Error404.vue";
import Error500 from "../components/routes/unauthenticated/Error500.vue";

/* Authenticated components */
import Dashboard from "../components/routes/authenticated/Dashboard.vue";
import Users from "../components/routes/authenticated/Users.vue";
import Partners from "../components/routes/authenticated/Partners.vue";
import Conductors from "../components/routes/authenticated/Conductors.vue";
import KonvaEditor from "../components/routes/authenticated/KonvaEditor.vue";
import KonvaViewer from "../components/routes/authenticated/KonvaViewer.vue";
import Orders from "../components/routes/authenticated/Orders.vue";
import Anomaly from "../components/routes/authenticated/Anomaly.vue";
import SystemSettings from "../components/routes/authenticated/SystemSettings.vue";
import Capacity from "../components/routes/authenticated/Capacity.vue";
import UsageArchive from "../components/routes/authenticated/UsageArchive.vue";
import TicketBuyerTypes from "../components/routes/authenticated/TicketBuyerTypes.vue";
import SalesStatistics from "../components/routes/authenticated/SalesStatistics.vue";
import UsedTickets from "../components/routes/authenticated/UsedTickets.vue";
import LockedItems from "../components/routes/authenticated/LockedItems.vue";
import Products from "../components/routes/authenticated/Products.vue";
import TicketBuyers from "../components/routes/authenticated/TicketBuyers.vue";
import CapacitySettings from "../components/routes/authenticated/CapacitySettings.vue";
import ProductGroup from "../components/routes/authenticated/ProductGroup.vue";
/* Layouts */
import AuthenticatedLayout from "../components/layouts/AuthenticatedLayout.vue";
import UnauthenticatedLayout from "../components/layouts/UnauthenticatedLayout.vue";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    components: {
      default: Dashboard,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/users",
    name: "Users",
    components: {
      default: Users,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0],
    },
  },
  {
    path: "/login",
    name: "Login",
    components: {
      default: Login,
      UnauthenticatedLayout,
    },
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPasswordScreen",
    components: {
      default: ResetPasswordScreen,
      UnauthenticatedLayout,
    },
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswordScreen",
    components: {
      default: ForgotPasswordScreen,
      UnauthenticatedLayout,
    },
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/partners",
    name: "Partners",
    components: {
      default: Partners,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0],
    },
  },
  {
    path: "/validation-users",
    name: "Conductors",
    components: {
      default: Conductors,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/konva-editor",
    name: "KonvaEditor",
    components: {
      default: KonvaEditor,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/konva-viewer",
    name: "KonvaViewer",
    components: {
      default: KonvaViewer,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/orders",
    name: "Orders",
    components: {
      default: Orders,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/capacity",
    name: "Capacity",
    components: {
      default: Capacity,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/usage-archive",
    name: "UsageArchive",
    components: {
      default: UsageArchive,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/sales-statistics",
    name: "SalesStatistics",
    components: {
      default: SalesStatistics,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/used-tickets",
    name: "UsedTickets",
    components: {
      default: UsedTickets,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/anomaly-log",
    name: "Anomaly",
    components: {
      default: Anomaly,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0],
    },
  },
  {
    path: "/system-settings",
    name: "SystemSettings",
    components: {
      default: SystemSettings,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0],
    },
  },
  {
    path: "/types",
    name: "TicketBuyerTypes",
    components: {
      default: TicketBuyerTypes,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [1],
    },
  },
  {
    path: "/locked-items",
    name: "LockedItems",
    components: {
      default: LockedItems,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0],
    },
  },
  {
    path: "/products",
    name: "Products",
    components: {
      default: Products,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/ticket-buyers",
    name: "TicketBuyers",
    components: {
      default: TicketBuyers,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/capacity-settings/:id",
    name: "CapacitySettings",
    components: {
      default: CapacitySettings,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [1],
    },
  },
  {
    path: "/product-group",
    name: "ProductGroup",
    components: {
      default: ProductGroup,
      AuthenticatedLayout,
    },
    meta: {
      authRequired: true,
      enabledToRole: [0, 1],
    },
  },
  {
    path: "/404",
    name: "Error404",
    components: {
      default: Error404,
      UnauthenticatedLayout,
    },
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/500",
    name: "Error500",
    components: {
      default: Error500,
      UnauthenticatedLayout,
    },
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    beforeEnter(to, from, next) {
      next("/");
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("From: ", from);
  console.log("To: ", to);

  const loggedInUser = store.getters["users/loggedInUser"];

  if (to.meta.authRequired && !loggedInUser) {
    next({ name: "Login" });
  } else if (
    loggedInUser &&
    (["Login", "ResetPasswordScreen", "ForgotPasswordScreen"].includes(
      to.name
    ) ||
      (to.meta.enabledToRole &&
        !to.meta.enabledToRole.includes(loggedInUser.role)))
  ) {
    next({ name: "/" });
  } else {
    next();
  }
});

export default router;
